import { useState } from 'react'
import axios from 'axios'
import { Modal, message } from 'antd'
import MyTextArea from '../../components/forms/textArea'

const EditJobFairNotifyPhones = (props) => {
  const [formValue, setFormValue] = useState({
    job_fair_notify_phones: props.data.job_fair_notify_phones || ''
  })
  
  const handleOk = () => {
    axios.post('/admin/event/config/update', { 
      job_fair_notify_phones: formValue.job_fair_notify_phones
    })
      .then(function (response) {
        if (response.errcode === 0) {
          props.isCancel()
          props.getEventConfig()
          message.success('修改成功！')
        } else {
          message.error(response.msg)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  return (
    <Modal 
      title='双选会通知短信接收号码'
      width='500px'
      open={props.isOpen}
      onOk={handleOk}
      onCancel={props.isCancel}
      cancelText="取消"
      okText="保存">

      <MyTextArea 
        id="job_fair_notify_phones"
        minRows={5}
        placeholder='多个手机号用逗号分隔，如：138xxx,139xxx'
        value={formValue.job_fair_notify_phones}
        onChange={setFormValue}
      />
    </Modal>
  )
}

export default EditJobFairNotifyPhones
